import React, { useEffect, useState } from "react";
import GalleryCard from "../Components/Gallery/GalleyCard";
import GalleryModal from "../Components/Gallery/GalleryModal";
import Background from "./../assets/resources/Lobby_view1.jpg";
import "./building_page.css";
import { supabase } from "../supabase/supabaseClient";
import { Helmet } from "react-helmet";

export default function Gallery() {
  const [packageData, setPackageData] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await supabase
        .from("gallery")
        .select("*")
        .order("sortorder", { ascending: true });
      if (res) {
        // Preload images
        res.data.forEach((item) => {
          if (item.type.search("image") >= 0) {
            const img = new Image();
            img.src = item.public_url;
          }
        });
        setPackageData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleMediaClick = (media) => {
    setSelectedMedia(media);
    setIsModalOpen(true);
  };

  return (
    <>
      <Helmet>
        <title>Gallery | Union Center Flushing Office Building</title>
        <meta
          name="description"
          content="Explore Union Center's photo gallery showcasing our modern office spaces, luxurious lobby, state-of-the-art facilities, and architectural design in Flushing, Queens."
        />
        <meta
          name="keywords"
          content="Union Center gallery, Flushing office photos, commercial real estate gallery, modern office building"
        />
        <link rel="canonical" href="https://www.3716union.com/gallery" />
      </Helmet>
      <div className="flex flex-col w-full mb-20 bg-white">
        <div className="relative">
          <img
            className="object-cover w-full h-screen"
            src={Background}
            alt="Background"
            fetchPriority="high"
            loading="eager"
          />
          <div className="absolute inset-0 bg-[#7e6140] opacity-30"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-white text-center text-5xl md:text-6xl font-normal">
              Gallery
            </h1>
          </div>
        </div>

        <div className="w-full px-4 py-16 bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10 max-w-[1200px] mx-auto">
            {packageData.map((item) => (
              <GalleryCard
                key={item.id}
                img={item.public_url}
                type={item.type}
                onClick={() => handleMediaClick(item)}
              />
            ))}
          </div>
        </div>

        <GalleryModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          media={selectedMedia?.public_url}
          type={selectedMedia?.type}
        />
      </div>
    </>
  );
}
